import ProductsPage from "../ProductsPage/ProductsPage";

const ServicesPage = () => {
    const productType = 1;

    return <ProductsPage productType={productType} />;
};

export default ServicesPage;
